// extracted by mini-css-extract-plugin
export default {"cls1":"LockedOut-Header_cls1__dtb61","cls2":"LockedOut-Header_cls2__1RiBE LockedOut-Header_cls1__dtb61"};